import React  from "react";
import ReactModal from "react-modal";
import { Input, Select, Radio  } from "@components/form";
import { Draggable, Pagination} from "@components";
import { FormProvider } from "react-hook-form";
import { useLectureApplyHistoryModal } from "@hooks";

function LectureApplyHistoryModal({ isOpen, onClose, lectureId }) {

  const position = Draggable({ isOpen, dragHandle: ".modal-header" });

  const containerStyle = {
    maxWidth: "1300px",
    minWidth: "1300px",
    maxHeight: "680px",
    minHeight: "680px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  const {
    methods, data, onSubmit,
    handlePageChange, resetSearch,
    pageIndex, recordCountPerPage,
  } = useLectureApplyHistoryModal(lectureId);



  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay"
      className="modal-wrap"
    >
      <div className="modal-container" style={containerStyle}>
          <div className="modal-header"  style={{ cursor: "move" }}>
            <h5>수강생 관리 이력</h5>
            <button type="button" className="modal-btn-close" onClick={onClose}>
              <span className="modal-btn-span">X</span>
            </button>
          </div>
        <FormProvider {...methods}>  
        <div className="modal-content">
          <div className="search-wrap">
            <div className="search-row">
              <div className="search-item">
                <Select
                  name="searchCnd"
                  options={[
                    { key: "0", name: "아이디" },
                    { key: "1", name: "이름" },
                  ]}
                  defaultOption="선택"
                  className="input-select"
                />
                <Input
                  name="searchWrd"
                  placeholder="검색어를 입력하세요"
                  className="input-search"
                  style={{ width: "250px" }}
                />
                <Radio name="applyStatusNm" label="전체" value="" />
                <Radio name="applyStatusNm" label="환불" value="승인취소(환불)" />
              </div>
              <div className="search-btn-container">
                <button type="button" className="btn-search" onClick={methods.handleSubmit(onSubmit)} >조회</button>
                <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
              </div>
            </div>
          </div>
           <div className="section-tit-wrap" style={{display:"flex", justifyContent:"space-between"}}>
                <h3 className="border-left-primary">
                  &nbsp;이력 목록
                  <span className="total-txt">
                    {" "} | 총 <span className="red">{data?.totalCount} 건</span> 
                  </span>
                </h3>
            </div>
            <div className="table-container">
            <table className="table-list" style={{ width: "100%" }}>
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "5%" }} />
                <col style={{ width: "10%" }} />
                {/* <col style={{ width: "20%" }} /> */}
              </colgroup>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>아이디</th>
                  <th>이름</th>
                  <th>연락처</th>
                  <th>관리이력</th>
                  <th>이력날짜</th>
                  {/* <th>메모</th> */}
                </tr>
              </thead>
              <tbody>
              {data?.resultList && data.resultList.length > 0 ? (
                    data.resultList.map((item, idx) => {
                      return (
                        <tr style={{ cursor: "pointer" }}  >
                          <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                          <td style={{textAlign:"left"}}>{item.memberId}</td>
                          <td>{item.memberNm}</td>
                          <td>{item.phoneNo}</td>
                          <td>{item.applyStatusNm}</td>
                          <td>{item.regDtm}</td>
                          {/* <td>{item.description}</td> */}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "center" }}>
                        조회 결과가 없습니다.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>

          </div>
          {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                <Pagination
                    totalPages={Math.ceil(
                    data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                    )}
                    currentPage={pageIndex}
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={recordCountPerPage}
                />
              )}
        </div>

        </FormProvider>
        <div className="modal-btn-wrap btn-right-box">
            <ul>
                <li><button type="button" className="btn-cancel" onClick={onClose}>닫기</button></li>
                
            </ul>
        </div>
      </div>
    </ReactModal>
  );
}

export {LectureApplyHistoryModal};
